"use strict";

var _interopRequireDefault = require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _appointment = _interopRequireDefault(require("../../components/softBusinessLogistics/appointment.vue"));
var _footNav = _interopRequireDefault(require("../../components/foot-nav"));
var _topNav = _interopRequireDefault(require("../../components/top-nav.vue"));
var _default = exports.default = {
  components: {
    appointment: _appointment.default,
    footNav: _footNav.default,
    topNav: _topNav.default
  },
  data: function data() {
    return {
      dialogVisible: false,
      navItems: ['镖神管家AI saas', '客户开发', '车辆调度', 'TMS功能'],
      currentSection: 0,
      isManualScrolling: false,
      // 增加一个“手动跳转中”的锁，防止点击导航时乱跳
      // 新增：记录当前选中的功能模块索引
      activeFeature: 0,
      featureContents: [{
        img: 'https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E8%BD%AF%E4%BB%B6%E8%A7%A3%E5%86%B3%E6%96%B9%E6%A1%88-AIsaas/1%E6%99%BA%E8%83%BD%E6%8B%93%E5%AE%A2.png',
        desc: '智能分析潜在客户...'
      }, {
        img: 'https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E8%BD%AF%E4%BB%B6%E8%A7%A3%E5%86%B3%E6%96%B9%E6%A1%88-AIsaas/2%E6%BD%9C%E5%AE%A2%E6%8E%A8%E8%8D%90.png',
        desc: '大数据精准算法推荐...'
      }, {
        img: 'https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E8%BD%AF%E4%BB%B6%E8%A7%A3%E5%86%B3%E6%96%B9%E6%A1%88-AIsaas/3%E6%8B%9B%E6%8A%95%E6%A0%87.png',
        desc: '实时监控全网招标信息...'
      }, {
        img: 'https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E8%BD%AF%E4%BB%B6%E8%A7%A3%E5%86%B3%E6%96%B9%E6%A1%88-AIsaas/4AI%E6%89%BE%E5%9B%9E%E7%A8%8B%E8%B4%A7.png',
        desc: 'AI自动匹配回程货源...'
      }],
      activeMenu: 0,
      // 默认选中第一个
      sideMenus: [{
        label: 'TMS流程',
        icon: 'https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E8%BD%AF%E4%BB%B6%E8%A7%A3%E5%86%B3%E6%96%B9%E6%A1%88-AIsaas/TMS%E6%B5%81%E7%A8%8B.png'
      }, {
        label: '经营分析',
        icon: 'https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E8%BD%AF%E4%BB%B6%E8%A7%A3%E5%86%B3%E6%96%B9%E6%A1%88-AIsaas/%E7%BB%8F%E8%90%A5%E5%88%86%E6%9E%90.png'
      }, {
        label: '运输订单',
        icon: 'https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E8%BD%AF%E4%BB%B6%E8%A7%A3%E5%86%B3%E6%96%B9%E6%A1%88-AIsaas/%E8%BF%90%E8%BE%93%E8%AE%A2%E5%8D%95.png'
      }, {
        label: '过程管控',
        icon: 'https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E8%BD%AF%E4%BB%B6%E8%A7%A3%E5%86%B3%E6%96%B9%E6%A1%88-AIsaas/%E5%A4%9A%E7%AB%AF%E4%BA%92%E8%81%94.png'
      }, {
        label: '路线创建',
        icon: 'https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E8%BD%AF%E4%BB%B6%E8%A7%A3%E5%86%B3%E6%96%B9%E6%A1%88-AIsaas/%E8%B7%AF%E7%BA%BF%E5%88%9B%E5%BB%BA.png'
      }, {
        label: '多端互联',
        icon: 'https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E8%BD%AF%E4%BB%B6%E8%A7%A3%E5%86%B3%E6%96%B9%E6%A1%88-AIsaas/%E5%A4%9A%E7%AB%AF%E4%BA%92%E8%81%94.png'
      }]
    };
  },
  methods: {
    //立即体验
    TryNow: function TryNow() {
      this.dialogVisible = true;
    },
    // 滚动监听
    handleScroll: function handleScroll(e) {
      // 如果正在执行点击跳转的平滑滚动，直接拦截，不执行逻辑
      if (this.isManualScrolling) return;
      var target = e.target;
      var scrollTop = target.scrollTop;
      var clientHeight = target.clientHeight;
      var scrollHeight = target.scrollHeight;

      // 核心计算：总共能滚动的最大距离
      var maxScroll = scrollHeight - clientHeight;

      // 如果内容还没到需要滚动的程度，直接返回
      if (maxScroll <= 0) return;

      // 计算当前滚动的百分比 (0 - 100)
      var progress = scrollTop / maxScroll * 100;
      var activeIndex = 0;

      // 根据你要求的百分比阈值进行判断
      // 注意：这里的逻辑是“大于某比例就切换到下一项”
      if (progress >= 80) {
        activeIndex = 3; // 对应第 4 个：TMS功能
      } else if (progress >= 55) {
        // 稍微给点余量，不用死扣 60
        activeIndex = 2; // 对应第 3 个：车辆调度
      } else if (progress >= 30) {
        // 对应 40 左右
        activeIndex = 1; // 对应第 2 个：客户开发
      } else {
        activeIndex = 0; // 对应第 1 个：镖神管家
      }

      // 只有索引变动时才更新视图，性能最优
      if (this.currentSection !== activeIndex) {
        console.log("\u5F53\u524D\u8FDB\u5EA6\uFF1A".concat(progress.toFixed(2), "%\uFF0C\u5207\u6362\u5230\u7D22\u5F15\uFF1A").concat(activeIndex));
        this.currentSection = activeIndex;
      }
    },
    // 点击导航平滑跳转
    scrollToSection: function scrollToSection(index) {
      var _this = this;
      var sections = document.querySelectorAll('.section');
      if (sections[index]) {
        // 1. 开启防跳锁
        this.isManualScrolling = true;
        this.currentSection = index;

        // 2. 执行平滑滚动
        sections[index].scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });

        // 3. 延迟 800 毫秒（等待滚动动画结束）后再解开锁
        setTimeout(function () {
          _this.isManualScrolling = false;
        }, 800);
      }
    }
  }
};